module.exports = __webpack_public_path__ + "static/media/messageBox-check.ffef582e.svg";